<template>
  <InfoPage>
    <h1 class="display-1 mt-2 mt-md-6 mt-lg-12 mb-6">{{ $t("erreur.paiement.titre") }}</h1>
    <p>{{ $t("erreur.paiement.description") }}</p>
    <p>{{ $t("erreur.paiement.telephone") }}</p>
  </InfoPage>
</template>

<script>
import InfoPage from "@/layouts/InfoPage"

export default {
  components: {
    InfoPage
  }
}
</script>

<style>
</style>